import { injectable, inject } from 'inversify';
import { DslRuntimeModule, moduleImplementation, RuntimeValue,
         runtimeValue, param, StringType, secondsAsDuration,
         Duration, DurationType, CourseType } from '@xlearn/common';
import { SectionStateQuerySymbol, SectionStateQuery } from './section-state-query';

@injectable()
export class CourseDslRuntimeModule implements DslRuntimeModule {

  public readonly ns = 'course';

  constructor(
    @inject(SectionStateQuerySymbol)
    private sectionStateStore: SectionStateQuery) {

  }

  get implementations() {
    return [
      moduleImplementation('time', (_) => this.courseTime(), param(CourseType)),
      moduleImplementation('object_reference', (_) => runtimeValue({}, CourseType), param(StringType))
    ];
  }

  private courseTime(): RuntimeValue {

    const seconds = this.sectionStateStore.courseTimeSeconds;

    const duration = secondsAsDuration(seconds);
    return runtimeValue<Duration>(duration, DurationType);
  }
}



